import { ADOBE_BOARD_ERROR_EVENT_KEY } from "../../../../../../services/analytics/constants";
import { ITEMS_TYPE_SHARED_BOARD } from "../../constants";

const getError = ({ itemsType, itemCountMismatch, itemCount }) => {
  if (itemsType !== ITEMS_TYPE_SHARED_BOARD) {
    return {};
  }

  if (itemCountMismatch === 0) {
    if (itemCount !== 0) {
      return {};
    }

    return { error: "empty board", events: [ADOBE_BOARD_ERROR_EVENT_KEY] };
  }

  if (itemCount !== 0) {
    return {
      error: "some items - country restriction",
      events: [ADOBE_BOARD_ERROR_EVENT_KEY]
    };
  }

  return {
    error: "all item - country restriction",
    events: [ADOBE_BOARD_ERROR_EVENT_KEY]
  };
};

export default getError;
